// extracted by mini-css-extract-plugin
export default {"description":"RemoveModal_description__ZcwcJ","removeButton":"RemoveModal_removeButton__gtjdW"};